"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FixedTypeField = void 0;
var _react = _interopRequireDefault(require("react"));
var _alloyReactFormField = _interopRequireDefault(require("@adsk/alloy-react-form-field"));
var _alloyReactTooltip = _interopRequireDefault(require("@adsk/alloy-react-tooltip"));
var _alloyReactIcon = require("@adsk/alloy-react-icon");
var _alloyReactDropdown = require("@adsk/alloy-react-dropdown");
var _TypeDisplayWithHydration = require("../input-field-components/TypeDropdown/TypeDisplayWithHydration");
var _consts = require("../utils/styles/consts");
var _useTranslations = require("../utils/i18n/useTranslations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FixedTypeField = _ref => {
  let {
    typeId
  } = _ref;
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  return /*#__PURE__*/_react.default.createElement(_alloyReactFormField.default, {
    style: {
      ..._consts.FIELD_WRAPPER_STYLE,
      overflowWrap: "anywhere"
    },
    label: T.translate("issueAttributes.issueType"),
    labelVariant: _alloyReactFormField.default.LABEL_VARIANTS.TOP,
    renderInfoPopover: () => {
      return /*#__PURE__*/_react.default.createElement(_alloyReactTooltip.default, {
        placement: _alloyReactTooltip.default.PLACEMENTS.RIGHT,
        variant: _alloyReactTooltip.default.VARIANTS.DARK,
        content: T.translate("issueCreation.disabledReason.fixedType")
      }, /*#__PURE__*/_react.default.createElement(_alloyReactIcon.AlertInformationIcon, {
        size: 16,
        style: {
          marginLeft: 2
        }
      }));
    }
  }, /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.Control, {
    disabled: true,
    isOpen: false,
    selectedItem: null,
    getToggleButtonProps: () => {
      return {};
    },
    renderPlaceholder: () => {
      return /*#__PURE__*/_react.default.createElement(_TypeDisplayWithHydration.TypeDisplayWithHydration, {
        typeId: typeId
      });
    }
  }));
};
exports.FixedTypeField = FixedTypeField;
//# sourceMappingURL=FixedTypeField.js.map